import { api } from '@/services/config/config';
import { Feedback } from '@/store/feedback/feedbackSlice';
import { mapFeedbackToRequest } from '@/utils/mappers/feedbackMapper';

export type FeedbackResponse = {
  content: string;
};

export type FeedbackRequest = {
  rating?: string;
  detailed_answer?: string;
  last_question?: string | null;
  last_answer?: string | null;
  follow_ups?: string[] | null;
  user_id: string;
};

const feedbackApi = api.injectEndpoints({
  endpoints: (build) => ({
    submitFeedback: build.mutation<FeedbackResponse, Feedback>({
      query: (feedback): { url: string; method: string; body: FeedbackRequest } => ({
        url: 'feedback/',
        method: 'POST',
        body: mapFeedbackToRequest(feedback),
      }),
    }),
  }),
});

export const { useSubmitFeedbackMutation } = feedbackApi;
